import { render, staticRenderFns } from "./GridBoardsModal.vue?vue&type=template&id=1ce142d1&scoped=true&"
import script from "./GridBoardsModal.vue?vue&type=script&lang=js&"
export * from "./GridBoardsModal.vue?vue&type=script&lang=js&"
import style0 from "./GridBoardsModal.vue?vue&type=style&index=0&id=1ce142d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce142d1",
  null
  
)

export default component.exports